/**
 * P0-16a / CLO-D7 — Egress allowlist status (NOT /sa/vault backup).
 * Live GET of env parse. CMC does not persist — ops SoT is EGRESS_URL_ALLOWLIST
 * + PG vault refs. Empty allowlist DENY. Never toast a fake save.
 */
import { html, Card, Alert, KV } from "./ui.js";
import { useSession } from "./session.js";
import { useApi } from "./api.js";

export function EgressCredPanel({ toast }) {
  const { me } = useSession();
  const role = String((me && me.role) || "").toLowerCase();
  const adminOk = role === "admin" || role === "superadmin";
  const live = useApi(adminOk ? "/ai/autonomy/egress-status" : null);

  if (!adminOk) {
    return html`<${Alert} tone="info" title="Egress"
      say="Only tenant admins read webhook egress allowlists. SA backup vault is a different page."/>`;
  }

  const hosts = (live.data && live.data.allowlist_hosts) || [];
  const n = Number((live.data && live.data.allowlist_n) || 0);
  const emptyDenies = live.data && live.data.empty_allowlist_denies === true;
  const emptyReason = String((live.data && live.data.empty_probe_reason) || "egress_allowlist_empty");
  const vaultN = Number((live.data && live.data.vault_pg_n) || 0);
  const vaultSot = String((live.data && live.data.vault_sot) || (live.data && live.data.vault_write_via) || "pg");
  const bootN = Number((live.data && live.data.vault_bootstrap_map_n) || (live.data && live.data.vault_map_n) || 0);
  const hostsLabel = n
    ? hosts.join(", ")
    : emptyDenies
      ? "empty — deny all"
      : "empty";

  return html`
    <${Card} title="Egress & credential refs"
        lede="Live allowlist from API hosts. This desk does not write env. /sa/vault is backup, not the credential store.">
      ${live.error ? html`<${Alert} tone="bad" title="Egress status refused" say=${String(live.error)}/>` : null}
      <div className="btn-row" style=${{ marginBottom: 8 }}>
        <button type="button" className="btn btn--ghost btn--sm"
          onClick=${() => live.reload && live.reload()}>Refresh live allowlist</button>
      </div>
      <${KV} k="Allowlist hosts" v=${hostsLabel}/>
      <${KV} k="Empty allowlist" v=${emptyDenies ? "DENY" : "hosts present"}/>
      <${KV} k="Vault store" v=${vaultSot === "pg" ? "PostgreSQL (encrypted refs)" : vaultSot}/>
      <${KV} k="Vault PG refs" v=${vaultN ? `${vaultN} (URLs never shown)` : "0 — vault:// unresolved until SA upsert"}/>
      <${KV} k="QA sink receipts" v=${live.data && live.data.qa_sink_receipts_n != null ? String(live.data.qa_sink_receipts_n) : "—"}/>
      <${KV} k="QA snapshot fixture" v=${live.data && live.data.qa_fixture_snapshot ? "present" : "—"}/>
      <${KV} k="Env map leftover" v=${bootN ? `${bootN} (not the live store)` : "0"}/>
      <${KV} k="Write path" v="Server allowlist + vault refs. This desk does not write."/>
      <${KV} k="CMC writable" v="no"/>
      <p className="note" data-cmc-egress-empty-denies=${emptyDenies ? "1" : "0"}
        data-cmc-egress-empty-reason=${emptyReason}>Private IP / DNS rebind / inline secrets deny in the executor. This card never toasts a fake save. Webhook credentials are vault:// refs, not /sa/vault.</p>
    </${Card}>
  `;
}
